import plural from 'lib/plural';
import { UserQuotaGroupId, UserQuotaGroupType } from 'reactApp/types/QuotaCleaner';

const pluralTitle = {
    [UserQuotaGroupType.Letter]: ['письмо', 'письма', 'писем'],
    [UserQuotaGroupType.Cloud]: ['файл', 'файла', 'файлов'],
};

const pluralGroupTitle = {
    [UserQuotaGroupId.Mounted]: ['папка', 'папки', 'папок'],
};

const pluralDeleteText = {
    [UserQuotaGroupType.Letter]: ['Удалено', 'Удалено', 'Удалено'],
    [UserQuotaGroupType.Cloud]: ['Удален', 'Удалено', 'Удалено'],
};

const pluralGroupDeleteText = {
    [UserQuotaGroupId.Mounted]: ['Удалена', 'Удалено', 'Удалено'],
};

export const getDeleteSnackbarText = (count: number, groupType: UserQuotaGroupType, groupId: UserQuotaGroupId): string => {
    const deleteTextSource = pluralGroupDeleteText[groupId] || pluralDeleteText[groupType];
    const titleSource = pluralGroupTitle[groupId] || pluralTitle[groupType];

    return `${deleteTextSource[plural(count)]} ${count}\xA0${titleSource[plural(count)]}`;
};

export const getRemoveSnackbarText = (count: number): string =>
    `Перемещено в корзину ${count}\xA0${pluralTitle[UserQuotaGroupType.Letter][plural(count)]}`;
